import styles from './style.module.css';

import { useEffect, useState } from 'react';
import { List, ListItem } from '../List';

import step1Image from '../../assets/images/step-1.png';
import step2Image from '../../assets/images/step-2.png';
import step3Image from '../../assets/images/step-3.png';
import step4Image from '../../assets/images/step-4.png';

interface ILeadSteps {
  step?: any;
  stepsNames: any;
  product?: string;
  registerDate?: string;
  description?: string;
  contact?: string | boolean;
  isCanceled?: string | boolean;
  businessName?: string;
  lead?: any;
  client?: any;
}

export function LeadSteps({
  step,
  product,
  registerDate,
  contact,
  stepsNames,
  description,
  isCanceled,
  businessName,
  lead,
  client,
}: ILeadSteps) {
  const [stepsListsImagesAdaptative, setStepsListsImagesAdaptative] =
    useState<Array<string>>();
  const [stepsListsTextsAdaptative, setStepsListsTextsAdaptative] =
    useState<Array<string>>();

  const stepsListImages: Array<string> = [];
  const stepsListTexts: Array<string> = [];

  useEffect(() => {
    if (stepsNames.length === 2) {
      stepsListImages[0] = step1Image;
      stepsListImages[1] = step4Image;
      stepsListTexts[0] = stepsNames[0].name;
      stepsListTexts[1] = stepsNames[1].name;
    }

    if (stepsNames.length === 3) {
      stepsListImages[0] = step1Image;
      stepsListImages[1] = step2Image;
      stepsListImages[2] = step4Image;
      stepsListTexts[0] = stepsNames[0].name;
      stepsListTexts[1] = stepsNames[1].name;
      stepsListTexts[2] = stepsNames[2].name;
    }

    if (stepsNames.length === 4) {
      stepsListImages[0] = step1Image;
      stepsListImages[1] = step2Image;
      stepsListImages[2] = step3Image;
      stepsListImages[3] = step4Image;
      stepsListTexts[0] = stepsNames[0].name;
      stepsListTexts[1] = stepsNames[1].name;
      stepsListTexts[2] = stepsNames[2].name;
      stepsListTexts[3] = stepsNames[3].name;
    }

    setStepsListsImagesAdaptative(stepsListImages);
    setStepsListsTextsAdaptative(stepsListTexts);
  }, []);

  const renderPreferenceInputs = (preferences) => {
    return preferences
      .filter((item) => item !== null && item !== undefined)
      .map((item) => (
        <ListItem content="imobiliária" secondaryContent={item.label} />
      ));
  };

  return (
    <>
      <div className={styles.stepsWrapper}>
        {stepsNames.map((steps: object, index: number) => {
          const stepLead = stepsListsTextsAdaptative?.indexOf(
            stepsListsTextsAdaptative[index]
          );

          return (
            <>
              {index === 0 && (
                <div
                  className={`${styles.step} ${styles.active} ${
                    step === stepLead
                      ? isCanceled
                        ? styles.canceled
                        : styles.progress
                      : ''
                  }`}
                >
                  <img
                    src={
                      stepsListsImagesAdaptative
                        ? stepsListsImagesAdaptative[index]
                        : ''
                    }
                    alt=""
                  />
                </div>
              )}

              {index > 0 && (
                <div
                  className={`${styles.step} ${
                    stepLead && step >= stepLead ? styles.active : ''
                  } ${
                    step === stepLead
                      ? isCanceled
                        ? styles.canceled
                        : styles.progress
                      : ''
                  }`}
                >
                  <img
                    src={
                      stepsListsImagesAdaptative
                        ? stepsListsImagesAdaptative[index]
                        : ''
                    }
                    alt=""
                  />
                </div>
              )}

              {index < stepsNames.length - 1 && (
                <div className={styles.divider}></div>
              )}
            </>
          );
        })}
      </div>
      <div className="mt-3">
        <span className="fw-semibold">Mais detalhes</span>
      </div>
      {client && client.clientUrl === 'bomnegocio' && (
        <iframe
          src={`https://maps.google.com/maps?q=${
            lead && lead.geoReference && lead.geoReference.lat
          },${
            lead && lead.geoReference && lead.geoReference.lng
          }&hl=pt&z=17&output=embed`}
          style={{ width: '100%', height: '300px', border: '0' }}
        ></iframe>
      )}

      <List>
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Solicitação"
            secondaryContent={lead.patrimonTypeAction}
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem content="Tipo" secondaryContent={lead.patrimonType} />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem content="CEP" secondaryContent={lead.patrimonCep} />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Endereço"
            secondaryContent={
              lead && lead.geoReference && lead.geoReference.address
            }
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Estado"
            secondaryContent={
              lead && lead.geoReference && lead.geoReference.state
            }
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Cidade"
            secondaryContent={
              lead && lead.geoReference && lead.geoReference.city
            }
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Bairro"
            secondaryContent={
              lead && lead.geoReference && lead.geoReference.district
            }
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Faixa de preço"
            secondaryContent={lead.patrimonPrice}
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Imóvel com exclusividade?"
            secondaryContent={lead && lead.patrimonUnique ? 'Sim' : 'Não'}
          />
        )}
        {client && client.clientUrl === 'bomnegocio' && (
          <ListItem
            content="Preferência por alguma imobiliária?"
            secondaryContent={lead && lead.patrimonPreference ? 'Sim' : 'Não'}
          />
        )}
        {client &&
          client.clientUrl === 'bomnegocio' &&
          lead &&
          lead.patrimonPreferenceNames &&
          renderPreferenceInputs(lead && lead.patrimonPreferenceNames)}
        <ListItem
          content="Step"
          secondaryContent={
            stepsListsTextsAdaptative ? stepsListsTextsAdaptative[step] : ''
          }
        />
        {product && <ListItem content="Produto" secondaryContent={product} />}
        {registerDate && (
          <ListItem content="Registro" secondaryContent={registerDate} />
        )}
        {contact && <ListItem content="Contato" secondaryContent={contact} />}
        {description && (
          <ListItem content="Origem" secondaryContent={description} />
        )}
        {businessName && (
          <ListItem content="Corretor" secondaryContent={businessName} />
        )}
      </List>
    </>
  );
}
